import {firestore} from "firebase-admin";
import Database from "./Database";
import {FirestoreDatabase} from "./Firestore";

let databaseInstance: Database | null = null;

function GetDatabase(firestore: firestore.Firestore): Database {
  if (!databaseInstance) {
    databaseInstance = new FirestoreDatabase(firestore);
  }
  return databaseInstance;
}

export default GetDatabase;

